/**
 * voice-v8 — Geteiltes Aktions-Menü (Pre.795, #54).
 *
 * „⋯ Mehr"-Aktionen als Sheet aus den BESTEHENDEN Klassen (.sheet /
 * .sheet-actions / .sheet-action wie das Plus-Sheet, .sheet--modal für
 * Desktop) — bewusst KEIN neues Popover-System. Eigener .sheet--menu-
 * Modifier hebt es auf z-1600, damit es auch ÜBER dem Projekt-Detail-
 * Sheet (z-1100) funktioniert. Schließt per Backdrop, Escape und Auswahl.
 */

interface ActionMenuItem {
  label: string;
  /** Dezente Beschreibung unter dem Label (optional). */
  hint?: string;
  danger?: boolean;
  onSelect: () => void;
}

export function openActionMenu(title: string, items: ActionMenuItem[]): void {
  const el = document.createElement("div");
  el.className = "sheet sheet--modal sheet--menu";
  el.setAttribute("role", "dialog");
  el.setAttribute("aria-modal", "true");

  const closeMenu = (): void => {
    el.remove();
    window.removeEventListener("keydown", onKey);
  };
  const onKey = (ev: KeyboardEvent): void => {
    if (ev.key === "Escape") closeMenu();
  };

  const backdrop = document.createElement("div");
  backdrop.className = "sheet-backdrop";
  backdrop.addEventListener("click", closeMenu);
  el.appendChild(backdrop);

  const card = document.createElement("div");
  card.className = "sheet-card";
  const h = document.createElement("h2");
  h.className = "sheet-title";
  h.textContent = title;
  card.appendChild(h);

  const ul = document.createElement("ul");
  ul.className = "sheet-actions";
  for (const item of items) {
    const li = document.createElement("li");
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className =
      "sheet-action" + (item.danger ? " sheet-action--danger" : "");
    const label = document.createElement("span");
    label.className = "sheet-action-label";
    const strong = document.createElement("strong");
    strong.textContent = item.label;
    label.appendChild(strong);
    if (item.hint) {
      const hint = document.createElement("span");
      hint.textContent = item.hint;
      label.appendChild(hint);
    }
    btn.appendChild(label);
    btn.addEventListener("click", () => {
      closeMenu();
      item.onSelect();
    });
    li.appendChild(btn);
    ul.appendChild(li);
  }
  card.appendChild(ul);
  el.appendChild(card);
  document.body.appendChild(el);
  window.addEventListener("keydown", onKey);
}
